var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.countriesLoaded
    ? _c(
        "div",
        _vm._l(
          _vm.question.propertyInfo.type.containedPropertyEntries,
          function(entry) {
            return _c("div", [
              entry.fragment.value == "firstname"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("Vorname")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.question.answer.value.firstname,
                          expression: "question.answer.value.firstname"
                        }
                      ],
                      attrs: { type: "text", id: "firstname" },
                      domProps: { value: _vm.question.answer.value.firstname },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.question.answer.value.firstname =
                            $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              entry.fragment.value == "lastname"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("Nachname")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.question.answer.value.lastname,
                          expression: "question.answer.value.lastname"
                        }
                      ],
                      attrs: { type: "text", id: "lastname" },
                      domProps: { value: _vm.question.answer.value.lastname },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.question.answer.value.lastname =
                            $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              entry.fragment.value == "street"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("Straße")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.question.answer.value.street,
                          expression: "question.answer.value.street"
                        }
                      ],
                      attrs: { type: "text", id: "street" },
                      domProps: { value: _vm.question.answer.value.street },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.question.answer.value.street = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              entry.fragment.value == "number"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("Hausnummer")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.question.answer.value.number,
                          expression: "question.answer.value.number"
                        }
                      ],
                      attrs: { type: "text", id: "streetno" },
                      domProps: { value: _vm.question.answer.value.number },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.question.answer.value.number = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              entry.fragment.value == "zip"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("PLZ")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.question.answer.value.zip,
                          expression: "question.answer.value.zip"
                        }
                      ],
                      attrs: { type: "text", id: "zip" },
                      domProps: { value: _vm.question.answer.value.zip },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.question.answer.value.zip = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              entry.fragment.value == "city"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("Ort")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.question.answer.value.city,
                          expression: "question.answer.value.city"
                        }
                      ],
                      attrs: { type: "text", id: "city" },
                      domProps: { value: _vm.question.answer.value.city },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.question.answer.value.city = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              entry.fragment.value == "country"
                ? _c("div", { staticClass: "lableFormContainer" }, [
                    _c("label", [_vm._v("Land")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.question.answer.value.country,
                            expression: "question.answer.value.country"
                          }
                        ],
                        attrs: { id: "country" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.question.answer.value.country = $event.target
                              .multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.countries, function(country) {
                        return _c("option", { domProps: { value: country } }, [
                          _vm._v(_vm._s(country))
                        ])
                      })
                    )
                  ])
                : _vm._e()
            ])
          }
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-90dcbad6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90dcbad6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressQuestion.vue
// module id = 242
// module chunks = 2